<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 账号设置
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-form :model="form" label-width="80px" ref="form">
        <div class="container">
            <div class="handle-box">

                    <el-row :gutter="20">
                        <el-col :span="5">
                            <el-form-item label="账号">
                                <el-input class='wd200' v-model="form.Uemail" :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="5">
                            <el-form-item label="姓名">
                                <el-input class='wd200' clearable v-model="form.Uname"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="5">
                            <el-form-item label="昵称">
                                <el-input class='wd200' clearable v-model="form.Usn"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-button @click="updateUserNameUsn()" icon="el-icon-refresh" type="success">保存/更改</el-button>
                        </el-col>
                    </el-row>

            </div>
        </div>
        <div class="container" style="margin-top: 20px">
            <div class="handle-box">

                    <el-row :gutter="20">
                        <el-col :span="5">
                            <el-form-item label="密码">
                                <el-input class="handle-input" clearable placeholder="请输入新密码" v-model="form.Upass"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-button @click="updateUserPwd()" icon="el-icon-refresh" type="warning">更改密码</el-button>
                        </el-col>
                    </el-row>

            </div>
        </div>
        </el-form>
    </div>

</template>

<script>

    export default {
        name: 'basetable',
        data() {
            return {
                uid: { userId: sessionStorage.getItem('yp_userid') },
                form: [],
            };
        },
        created() {
            this.initUser();
        },
        methods: {
            //初始化 用户信息
            async initUser() {
                const { data: res } = await this.$http.get('/admin/partner/initUser', {
                    params:this.uid
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取数据失败，请联系管理员!');
                }
                this.form = res.user;
                return this.$message.success('用户数据初始化成功!');
            },

            // 更改用户信息
            async updateUserNameUsn() {

                if (this.form.Uname < 2||this.form.Usn<2) {
                    return this.$message.error('请认真填写姓名和昵称!');
                }

                const { data: res } = await this.$http.post('/admin/partner/updateUserNameUsn', {
                    Uid:this.form.Id,
                    Uname:this.form.Uname,
                    Usn:this.form.Usn
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取数据失败，请联系管理员!');
                }
                this.form = res.user;
                return this.$message.success(res.message);
            },

            // 更改 密码信息
            async updateUserPwd() {
                if (this.form.Upass <4) {
                    return this.$message.error('请输入密码，长度大于3！');
                } else {
                    const { data: res } = await this.$http.post('admin/partner/updateUserPwd', {
                        Upasswd: this.form.Upass,
                        Uid:this.form.Id,
                    });
                    if (res.code === 200) {
                        this.$message.success(res.message + '，下次登录需新密码!');
                    }
                }
            }
        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;

    }

    .handle-input {
        width: 220px;
        margin: 0px 10px;
        display: inline-block;
    }

</style>
